import { useEffect } from "react";

import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useAdsConversionSharingCountry } from "@/lib/adsConversionSharing";
import {
  isRedditAdsRolloutCountry,
  setRedditAdsMeasurementState,
} from "@/lib/redditAdsMeasurement";

export function RedditAdsTag({ pixelId, countryCode }: { pixelId: string; countryCode?: string }) {
  const {
    isAuthenticated,
    isConsentRequired,
    isConsentResolved,
    isGlobalPrivacyControlEnabled,
    marketingConsent,
    marketingConsentEnabled,
  } = useCookieConsent();
  const isRolloutCountry = isRedditAdsRolloutCountry(countryCode);
  const shouldShareAllConversions = useAdsConversionSharingCountry("reddit", countryCode);
  const isRequiredConsentPending =
    !isAuthenticated &&
    isConsentRequired === true &&
    marketingConsent == null &&
    !isGlobalPrivacyControlEnabled;
  const isMeasurementConsentResolved =
    isConsentResolved &&
    (isAuthenticated || isConsentRequired !== undefined) &&
    !isRequiredConsentPending;
  const shouldClearAttribution =
    !isRolloutCountry ||
    isGlobalPrivacyControlEnabled ||
    (isMeasurementConsentResolved && !marketingConsentEnabled);
  const isMeasurementEligibilityResolved = isMeasurementConsentResolved || shouldClearAttribution;
  const measurementEnabled =
    isMeasurementConsentResolved && marketingConsentEnabled && Boolean(pixelId) && isRolloutCountry;

  useEffect(() => {
    setRedditAdsMeasurementState({
      enabled: measurementEnabled,
      isConsentResolved: isMeasurementEligibilityResolved,
      shouldClearAttribution,
      shouldShareAllConversions,
      configuredPixelId: pixelId,
    });
    return () =>
      setRedditAdsMeasurementState({
        enabled: false,
        isConsentResolved: isMeasurementEligibilityResolved,
        shouldClearAttribution,
        configuredPixelId: pixelId,
      });
  }, [
    isMeasurementEligibilityResolved,
    measurementEnabled,
    pixelId,
    shouldClearAttribution,
    shouldShareAllConversions,
  ]);

  return null;
}
